<template>
  <Teleport to="body">
    <div class="toast-container">
      <TransitionGroup name="toast">
        <div
          v-for="toast in toasts"
          :key="toast.id"
          :class="['toast', `toast--${toast.type}`]"
          @click="removeToast(toast.id)"
        >
          <span class="toast__message">{{ toast.message }}</span>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { useToast } from '../composables/useToast'

const { toasts, removeToast } = useToast()
</script>

<style scoped>
.toast-container {
  position: fixed;
  bottom: var(--spacing-lg, 1rem);
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm, 0.5rem);
  pointer-events: none;
}

.toast {
  min-width: 200px;
  max-width: 400px;
  padding: var(--spacing-md, 0.75rem) var(--spacing-lg, 1rem);
  border-radius: var(--radius-md, 0.625rem);
  font-size: 0.875rem;
  line-height: 1.43;
  font-weight: 500;
  pointer-events: auto;
  cursor: pointer;
  box-shadow: var(--shadow-popover);
}

.toast--success {
  background-color: var(--color-success, #10b981);
  color: white;
}

.toast--error {
  background-color: var(--color-danger, #f43f5e);
  color: white;
}

.toast--info {
  background-color: var(--color-info, #0ea5e9);
  color: white;
}

.toast--warning {
  background-color: var(--color-warning, #f59e0b);
  color: white;
}

.toast__message {
  display: block;
  text-align: center;
}

/* Анимации */
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.toast-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
